var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"wRtTCkEl8KSymdltBSPhK"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "/messenger-build/5df01de37dbeaf25528928208bc6af4ed2a0f9c7";

import * as Sentry from '@sentry/nextjs';

const env = process.env.NEXT_PUBLIC_TARGET_ENV || 'development';
const isProduction = env === 'production';
const SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN;

if (isProduction) {
  if (!SENTRY_DSN) {
    throw new Error('SENTRY_DSN is not set');
  }

  Sentry.init({
    dsn: SENTRY_DSN,
    environment: env,
    tracesSampleRate: 1.0,
  });
}
